import { BNB } from '@/config/constants/bnb';

export const isBnb = token => {
  if (token.address.toLowerCase() === BNB.address.toLowerCase() && token.name.toLowerCase() === BNB.symbol.toLowerCase()) {
    return true;
  }

  return false;
};



